import { Stack, Typography } from '@mui/material';
import { CustomCheckbox, FileUpload, RadioButtons } from 'Components';
import { yesNoOptions } from 'Constants';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { IndexContext } from 'Modules/CaseDetails/CaseContext';
import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { isFileExist } from 'Utils/isFileExist';

export const MedicalCenter = () => {
  const { index, fieldId } = useContext(IndexContext);

  const filesList = useAppSelector(({ file: { files } }) => files);

  const dictionary = useDictionary(Dictionary, DICTIONARY.CASE_DETAILS);

  const baseName = `caseDetails.${index}`;

  const [isPrevHmoExist, hasNoHmoFile, hasNoPrevHmoFile] = useWatch({
    name: [
      `${baseName}.isPrevHmoExist`,
      `${baseName}.hasNoHmoFile`,
      `${baseName}.hasNoPrevHmoFile`,
    ],
  });

  return (
    <Stack gap='20px' mt='16px'>
      <Stack gap='10px'>
        <Typography sx={{ fontWeight: 'bold' }}>
          {dictionary.fifthSectionMedicalCenterTitle}
        </Typography>
        <Typography>{dictionary.fifthSectionMedicalCenterTitleDesc}</Typography>
      </Stack>
      <Stack>
        <FileUpload
          caseDetailsId={fieldId}
          fileLabel={dictionary.fifthSectionMedicalCenterTitle}
          fileCategoryId={FileCategories.HmoFile}
          ariaLabel={dictionary.fifthSectionMedicalCenterTitle}
          disabled={hasNoHmoFile}
          dataRequired={!hasNoHmoFile}
        />
        {!isFileExist(filesList, FileCategories.HmoFile) && (
          <CustomCheckbox
            name={`${baseName}.hasNoHmoFile` as `caseDetails.0.hasNoHmoFile`}
            label={dictionary.noInformationOrRemember}
          />
        )}
      </Stack>
      <RadioButtons
        id={dictionary.fifthSectionOtherMedicalCenter}
        name={`${baseName}.isPrevHmoExist` as const}
        options={yesNoOptions}
      />
      {isPrevHmoExist && (
        <Stack gap='10px' sx={{ mt: '20px' }}>
          <Typography>
            {dictionary.fifthSectionOtherMedicalCenterTitle}
          </Typography>
          <Stack>
            <FileUpload
              caseDetailsId={fieldId}
              fileLabel={dictionary.fifthSectionMedicalCenterTitle}
              fileCategoryId={FileCategories.PrevHmoFile}
              ariaLabel={dictionary.fifthSectionMedicalCenterTitle}
              disabled={hasNoPrevHmoFile}
            />
            {!isFileExist(filesList, FileCategories.PrevHmoFile) && (
              <CustomCheckbox
                name={
                  `${baseName}.hasNoPrevHmoFile` as `caseDetails.0.hasNoPrevHmoFile`
                }
                label={dictionary.fifthSectionNoMedicalFileInfo}
              />
            )}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
